module.exports = __webpack_public_path__ + "static/media/delivery.b1e371c3.svg";